<div class="in_vitro_fertilization header_top mb-5">
  <section class="treatment_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Advanced Procedures & Techniques</h6>
        <h5>For improved IVF Success</h5>
        <p>
          At NCare IVF Kannur, Kerala, we go beyond conventional fertility
          treatments with advanced procedures like Blastocyst Culture &
          Transfer, Laser-Assisted Hatching, and Diagnostic & Advanced Operative
          Hysterolaparoscopy. These techniques enhance implantation rates,
          improve pregnancy success, and help diagnose and treat underlying
          fertility issues — all under expert care.
        </p>
        <button [routerLink]="['/contact-us']">Book an Appointment</button>
      </div>
    </div>
  </section>
  <section class="how_does_work_ivf mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h6>Who Can Benefit from These Advanced Fertility Treatments?</h6>
          <ul>
            <li>Couples experiencing repeated IVF failure</li>
            <li>Women with poor embryo implantation history</li>
            <li>Patients with unexplained infertility</li>
            <li>Women with suspected uterine or pelvic abnormalities</li>
            <li>Couples preparing for IVF or ICSI</li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            loading="lazy"
            src="../../assets/images/treatment/how_ivf.webp"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>
  <section class="blastocyst_culture_transfer mt-5">
    <div class="container">
      <div class="card">
        <div class="card-content">
          <h1>Blastocyst Culture & Transfer</h1>

          <h2>What is Blastocyst Culture?</h2>
          <p>
            In standard IVF, embryos are transferred on Day 2 or 3. With
            Blastocyst Culture, embryos are grown in the lab for 5–6 days,
            allowing the strongest embryos to develop to the blastocyst stage
            before transfer.
          </p>

          <h2>Advantages of Blastocyst Transfer:</h2>
          <ul>
            <li>Higher implantation rates</li>
            <li>Better embryo selection</li>
            <li>Reduced chances of multiple pregnancies</li>
            <li>
              Ideal for patients with repeated IVF failure or seeking single
              embryo transfer
            </li>
          </ul>

          <h2>How It Works:</h2>
          <ul>
            <li>
              Embryos are cultured in advanced lab conditions until Day 5 or 6
            </li>
            <li>High-quality blastocysts are selected for transfer</li>
            <li>Remaining viable blastocysts can be frozen for future use</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="laser_assisted_hatching">
    <div class="container">
      <div class="card">
        <div class="content">
          <h1>Laser-Assisted Hatching (LAH)</h1>

          <div class="section">
            <h2>What is Laser-Assisted Hatching?</h2>
            <p>
              Sometimes, an embryo’s outer shell (zona pellucida) can be too
              thick or hardened, reducing its ability to implant successfully.
              Laser-Assisted Hatching carefully creates a tiny opening using
              precision lasers, helping the embryo implant into the uterus.
            </p>
          </div>

          <hr />

          <div class="section">
            <h2>Who Needs LAH?</h2>
            <ul>
              <li>Women over 35</li>
              <li>Embryos with thick zona pellucida</li>
              <li>Cases of repeated implantation failure</li>
            </ul>
          </div>

          <hr />

          <div class="section">
            <h2>Benefits of LAH</h2>
            <ul>
              <li>Enhances implantation chances</li>
              <li>Minimally invasive and highly precise</li>
              <li>Conducted by expert embryologists under lab standards</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="diagnostic_advance_operactive">
    <div class="container">
      <div class="card">
        <div class="card-body">
          <h1>Diagnostic & Advanced Operative Hysterolaparoscopy</h1>

          <div class="section">
            <h2>What is Hysterolaparoscopy?</h2>
            <p>
              Hysterolaparoscopy combines hysteroscopy (visual inspection of the
              uterus) and laparoscopy (keyhole surgery to view pelvic organs).
              It is used to diagnose and treat infertility-related conditions
              effectively.
            </p>
          </div>

          <div class="section">
            <h2>When is it Recommended?</h2>
            <ul>
              <li>Unexplained infertility</li>
              <li>
                Suspected fibroids, polyps, endometriosis, or pelvic adhesions
              </li>
              <li>Recurrent miscarriage or implantation failure</li>
              <li>Prior to IVF cycles for uterine assessment</li>
            </ul>
          </div>

          <div class="section">
            <h2>What Does it Involve?</h2>
            <ul>
              <li>
                <strong>Diagnostic Hysterolaparoscopy:</strong> Identifies
                abnormalities in the uterus, fallopian tubes, and ovaries.
              </li>
              <li>
                <strong>Operative Hysterolaparoscopy:</strong> Corrects
                conditions like fibroids, polyps, adhesions, and endometriosis
                during the same procedure.
              </li>
            </ul>
          </div>

          <div class="section">
            <h2>Benefits of Hysterolaparoscopy</h2>
            <ul>
              <li>Minimally invasive with quick recovery</li>
              <li>Accurate diagnosis and immediate treatment</li>
              <li>
                Improves fertility outcomes by addressing underlying issues
              </li>
              <li>Performed by experienced fertility surgeons</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <!-- <h5>CTA BANNER CONTENT</h5> -->
        <p>Boost your IVF success with advanced fertility techniques.</p>
        <button (click)="contactus()">Book a Consultation</button>
      </div>
    </div>
  </section>

  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h4 class="title_header tac">
        Why Choose NCare IVF Kannur, Kerala for Advanced Fertility Procedures?
      </h4>

      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/advance_procedure_technique/afp_1.webp"
              alt=""
            />
            <h5>State-of-the-Art IVF Lab</h5>
            <p>Latest technology for embryo culture and micromanipulation</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/advance_procedure_technique/afp_2.webp"
              alt=""
            />
            <h5>Experienced Embryologists & Surgeons</h5>
            <p>Skilled specialists with proven track records</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/advance_procedure_technique/afp_3.webp"
              alt=""
            />
            <h5>Comprehensive Monitoring</h5>
            <p>
              Each procedure is performed with precision and continuous
              monitoring
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/advance_procedure_technique/afp_4.webp"
              alt=""
            />
            <h5>Patient-Centric Care</h5>
            <p>Personalized fertility care plans with detailed counseling</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/advance_procedure_technique/afp_5.webp"
              alt=""
            />
            <h5>Minimally Invasive Approach</h5>
            <p>
              Faster recovery and reduced discomfort with advanced surgical
              techniques
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Is Blastocyst Transfer better than regular embryo transfer?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Yes, it allows for better embryo selection and increases chances
              of successful implantation.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Is Laser-Assisted Hatching safe?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Absolutely. It’s a quick, safe procedure performed by trained
              embryologists with precise laser technology.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How long does recovery take after hysterolaparoscopy?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Most patients resume normal activities within 2–3 days.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Will I need all these advanced procedures for IVF?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Not necessarily. Our fertility experts will recommend these
              procedures only when they are clinically beneficial to improve
              your outcomes.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Can hysteroscopy and laparoscopy treat infertility?
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Yes, by correcting conditions like fibroids, polyps, or adhesions,
              it enhances natural fertility and IVF success.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
